// src/theme/theme.js
import { createTheme } from "@mui/material/styles";

export const makeTheme = (mode = "light") => {
  const isDark = mode === "dark";

  const primaryMain = isDark ? "#8b5cf6" : "#6d28d9";
  const secondaryMain = isDark ? "#22c55e" : "#16a34a";

  const bgDefault = isDark ? "#0b1020" : "#f6f7fb";
  const bgPaper = isDark ? "#0f1833" : "#ffffff";

  const borderColor = isDark ? "#1f2a44" : "#e5e7eb";
  const scrollbarThumb = isDark ? "#334155" : "#cbd5e1";
  const scrollbarTrack = isDark ? "#0b1020" : "#eef2ff";

  return createTheme({
    palette: {
      mode,
      primary: { main: primaryMain },
      secondary: { main: secondaryMain },
      background: { default: bgDefault, paper: bgPaper },
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: '"Sora", "IBM Plex Sans", "Segoe UI", sans-serif',
      h1: { fontFamily: '"Newsreader", "Times New Roman", serif' },
      h2: { fontFamily: '"Newsreader", "Times New Roman", serif' },
      h3: { fontFamily: '"Newsreader", "Times New Roman", serif' },
      h4: { fontFamily: '"Newsreader", "Times New Roman", serif' },
    },

    components: {
      MuiCssBaseline: {
        styleOverrides: {
          "html, body, #root": { minHeight: "100%" },
          "html, body": {
            margin: 0,
            overflowY: "auto",
            overflowX: "hidden",
          },
          "#root": {
            minHeight: "100vh",
          },
          body: {
            backgroundColor: bgDefault,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
          },

          "::selection": { background: primaryMain, color: "#fff" },

          "*::-webkit-scrollbar": { width: 10, height: 10 },
          "*::-webkit-scrollbar-thumb": {
            background: scrollbarThumb,
            borderRadius: 20,
          },
          "*::-webkit-scrollbar-track": { background: scrollbarTrack },

          a: { color: primaryMain, textDecoration: "none" },
          "a:hover": { textDecoration: "underline" }, // ✅ QUOTED
        },
      },

      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: "none", border: `1px solid ${borderColor}` },
        },
      },

      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { textTransform: "none", borderRadius: 12 },
        },
      },

      MuiDataGrid: {
        styleOverrides: {
          root: { border: `1px solid ${borderColor}`, borderRadius: 12 },
        },
      },
    },
  });
};
